{{ hasAlias ? alias : (item?.field | fieldAlias: fields) }}:
{{
  item?.operator === filterTypeEq
    ? item.text
    : (item.operator | filterOperator) + " " + item.text
}}
